module.exports = __webpack_public_path__ + "img/home_outlined.73ef455b.svg";